import type { SearchDropdownItem } from '@/components/ui/search-dropdown'
import type { HubspotAssignee } from '@super/shared-types'

export const mapAssigneeToItem = (
  assignee: HubspotAssignee,
): SearchDropdownItem<string> => ({
  id: assignee.id,
  label: assignee.name || assignee.email || assignee.id,
  sublabel: assignee.email || undefined,
  data: assignee.id,
})
